import * as Yup from 'yup';

export const specialistFormSchema = Yup.object({
    id: Yup.string().optional(),
    fullName: Yup.string()
        .required('Imię i nazwisko jest wymagane')
        .min(2, 'Imię i nazwisko musi mieć co najmniej 2 znaki')
        .max(100, 'Imię i nazwisko może mieć maksymalnie 100 znaków'),
    
    phoneNumber: Yup.string()
        .required('Numer telefonu jest wymagany')
        .matches(/^\d{3}-\d{3}-\d{3}$/, 'Numer telefonu musi być w formacie xxx-xxx-xxx')
        .length(11, 'Numer telefonu musi mieć dokładnie 11 znaków (xxx-xxx-xxx)'),
    
    specialization: Yup.string()
        .required('Specjalizacja jest wymagana')
        .min(2, 'Specjalizacja musi mieć co najmniej 2 znaki')
        .max(100, 'Specjalizacja może mieć maksymalnie 100 znaków'),
    
    websiteUrl: Yup.string()
        .required('Link do strony internetowej jest wymagany')
        .url('Podaj prawidłowy adres URL strony internetowej'),
    
    znanyLekarzUrl: Yup.string()
        .optional()
        .transform((value) => value?.trim() || undefined)
        .url('Podaj prawidłowy adres URL profilu na ZnanyLekarz'),
    
    image: Yup.mixed()
        .optional()
});

export type SpecialistFormSchemaType = Yup.InferType<typeof specialistFormSchema>;
